// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3329":"d00590d3","7858":"7b03e317"}[chunkId] + ".chunk.css";
};